import { configureStore } from "@reduxjs/toolkit";
import resumeReducer from "lib/redux/resumeSlice";
import settingsReducer from "lib/redux/settingsSlice";
import uiReducer from "lib/redux/uiSlice";
import scoringReducer from "lib/redux/scoringSlice";
import scoreAnalysisReducer from "./scoreAnalysisSlice";
import highlightReducer from "./highlightSlice";
import { redirectSlice } from "./redirect";
import jobsReducer from "./jobsSlice";

export const store = configureStore({
  reducer: {
    resume: resumeReducer,
    settings: settingsReducer,
    ui: uiReducer,
    scoring: scoringReducer,
    scoreAnalysis: scoreAnalysisReducer,
    redirect: redirectSlice.reducer,
    highlight: highlightReducer,
    jobs: jobsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
